import React, { PropsWithChildren } from 'react';
import styles from './Heading.module.scss';

export const Heading = ({ children }: Props) => (
    <h4 className={styles.default}>{children}</h4>
);

type Props = PropsWithChildren<{}>;
